/* @flow */
import * as React from 'react';

import Heading from 'components/Heading';

type Props = {
  children: React.Node,
};

export default function GroupsContentTitle({ children }: Props) {
  return (
    <Heading align="left" flush className="GroupsContentTitle">
      {children}
    </Heading>
  );
}
